var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.591 3.69H8.02A4.11 4.11 0 0 0 3.91 7.796v5.572a4.11 4.11 0 0 0 4.108 4.109h5.572a4.11 4.11 0 0 0 4.108-4.109V7.797A4.11 4.11 0 0 0 13.59 3.69m2.721 9.68a2.72 2.72 0 0 1-2.72 2.72H8.018a2.72 2.72 0 0 1-2.72-2.72V7.796a2.72 2.72 0 0 1 2.72-2.72h5.572a2.72 2.72 0 0 1 2.72 2.72z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.805 7.019a3.57 3.57 0 0 0-3.565 3.565 3.57 3.57 0 0 0 3.565 3.564 3.57 3.57 0 0 0 3.565-3.564 3.57 3.57 0 0 0-3.565-3.565m0 5.742a2.178 2.178 0 1 1 0-4.355 2.178 2.178 0 0 1 0 4.355m3.573-6.57a.855.855 0 1 1-.855.855c0-.472.32-.855.854-.855"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.208d2c552a068750856ff0df18d3def3.svg";
export { ForwardRef as ReactComponent };